var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRestart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-768 -314)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32994 7.59005C3.55994 10.2301 3.55994 13.7801 5.32994 16.4101C8.01994 20.4101 13.2799 21.0601 16.8199 18.4001C17.2999 18.0301 17.3399 17.3201 16.9099 16.8901C16.5599 16.5401 15.9999 16.5101 15.6199 16.8001C12.9399 18.8001 8.95994 18.2801 6.96994 15.2301C5.69994 13.3001 5.69994 10.7 6.96994 8.77005C9.12994 5.45005 13.6299 5.12005 16.2699 7.76005L14.2999 9.73005C13.9799 10.0501 14.2099 10.5901 14.6499 10.5901H20.0099C20.2899 10.5901 20.5099 10.3701 20.5099 10.0901V4.72005C20.5099 4.27005 19.9699 4.05005 19.6499 4.37005L17.6799 6.34005C14.1799 2.85005 8.25994 3.26005 5.32994 7.59005Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestart);
export default __webpack_public_path__ + "static/media/icon-restart.992e037dd20366f5f109f20eef8a66cd.svg";
export { ForwardRef as ReactComponent };